import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectProductForBillGenerate {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectProductForBillGenerate = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectProductForBillGenerate) => {
  const itemList = useStoreState((state) => state.order.productList);
  const itemListFetch = useStoreActions((state) => state.order.fetchproductList);

  React.useEffect(() => {
    itemListFetch();
  }, [])

  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.productId === id);
      onChange(val);
    }
  };

  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      allowClear
      defaultValue={defaultSelected}
      value={selected?.productId}
      style={style}
      placeholder="Select Product"
      filterOption={(input, option) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.productId} value={type.productId}>
            {type.productName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Products</Option>
      )}
    </Select>
  );
};
